module.exports = __webpack_public_path__ + "static/media/cocking_1.1b8b09ae.mp3";